import TableVM from '../../../instructor/gradebook/table-vm';

export default {
  data: {
    users: [],
    paginator: null,
    users_count: null,
    selected_user: null,
    selected_role: null,
    selected_course: null,
    selected_roles: null,
    assignable_roles: null,
    search_query: '',
    search_applied: null,
    show_role_modal: false,
    per_page: 25,
    terms: [],
    checked_terms: [],
    sort_options: [
      { id: 1, name: 'Last Name Ascending', param: 'last_name', direction: 'asc' },
      { id: 2, name: 'Last Name Descending', param: 'last_name', direction: 'desc' },
      { id: 3, name: 'Email Ascending', param: 'email', direction: 'asc' },
      { id: 4, name: 'Email Descending', param: 'email', direction: 'desc' }
    ],
    selected_sort: {},
    roles: [
      'admin',
      'auditor',
      'course_creator',
      'instructional_support',
      'instructor',
      'mentor',
      'staff',
      'student',
      'teaching_assistant',
      'ambassador',
      'graduate_teaching_assistant'
    ],
    filter_roles: [],
  },

  computed: {
    shareName() {
      if (this.user && this.course)
        return this.user.full_name + ' has successfully completed an online offering of ' + this.course.name + ' on Kadenze';
      else
        return '';
    },

    shareableObj() {
      return {
        title: this.shareName,
        description: null,
        share_url: this.user && this.user.share_link || null
      };
    },

    sortDirection() {
      return this.selected_sort ? this.selected_sort.direction : '';
    },

    sortParam() {
      return this.selected_sort ? this.selected_sort.param : '';
    }

  },

  watch: {
    selected_role() { this.filterChanged(); },
    checked_terms() { this.filterChanged(); },
    selected_sort() { this.filterChanged(); },
    per_page() { this.filterChanged(); },
    search_query() { this.filterChanged(); }
  },

  methods: {
    bindData(data) {
      this.users = data.users;
      this.paginator = data.paginator;
      this.users_count = data.users_count;
      this.terms = data.terms;
      this.assignable_roles = data.assignable_roles;

      let self = this;
      // setTimeout is necessary for now b/c the html binding re-renders the dom when we paginate
      // so we have to wait a few to attach event listeners. This really needs to be rewritten soon.
      setTimeout(function() {
        Kadenze.PaginationBinding.applyBindingsWithTextInput(self.userListing);
      }, 200);
    },

    filteredRoles(roles) {
      return roles.map(role => {
        return {
          key: role,
          value: I18n.t(`roles.${role}`),
        };
      })
    },

    selectRole(user) {
      this.selected_user = user;
      this.selected_roles = user.global_roles;
      this.show_role_modal = true;
      // this.$edit_role_modal.modal('show');
    },

    changeRole() {
      // self.$edit_role_modal.modal('hide');
      let url = Kadenze.Routes.change_global_role_admin_user_path(this.selected_user.id);
      let method = 'PATCH';
      let data = {
        old_roles: this.selected_user.global_roles,
        new_roles: this.selected_roles,
        user_id: this.selected_user.id
      };

      let request = new Kadenze.AjaxRequest({
        type: method,
        url: url,
        data: data,
        dataAsJson: false
      });

      let self = this;
      request.done(function(data) {
        new Kadenze.Notice.success({message: data.message});
        self.selected_user.global_roles = self.selected_roles;
        let userRoles = self.selected_user.roles;
        let globalRoles = data.added_roles;
        let unionRoles = _.union(userRoles.split(/,\s*/), globalRoles);
        unionRoles = _.difference(unionRoles, data.removed_roles);
        self.selected_user.roles = unionRoles.join(', ');
        self.selected_roles = [];
        self.selected_user = null;
      });

      request.fail(function(data) {
        new Kadenze.Notice.error({message: data.message});
      });

      request.always(function() {
        self.show_role_modal = false;
      });
    },

    resetSelected() {
      // this.client_errors = ko.validation.group(self.selected_course(), { deep: true });
      this.selected_user = null;
      this.selected_course.id = '';
      this.selected_course.name = '';
      // this.client_errors.showAllMessages(false);
    },

    initInviteCopyLinks() {
      let cb = new Clipboard('.js-invite-copy');
      cb.on('success', function() {
        new Kadenze.Notice.success({
          message: 'Invitation link copied to clipboard!'
        });
      });
    },

    typeaheadListing(query) {
      let url = Kadenze.Routes.list_admin_users_path() + '?q=' + query['q'] + '&type=name';
      return new Kadenze.AjaxRequest({
        type: 'GET',
        url: url
      });
    },

    userListing(url, params) {
      // Kadenze.UIUtil.showLoadingIndicator();
      let self = this;

      //load the entries info from the server
      url = url ? url : Kadenze.Routes.admin_users_path();
      if (params) {
        url += '?' + params;
      }

      let request = new Kadenze.AjaxRequest({
        type: 'GET',
        url: url,
        loadingIndicator: true
      });

      request.done(function (data) {
        self.bindData(data);
      });

      request.error(function (data) {
        console.log(data);
      });
    },

    getSort() {
      return _.find(self.sort_options, function(option) { return option.id === id; });
    },

    filterChanged() {
      let params = {
        sort: this.sortParam,
        per_page: this.per_page,
        direction: this.sortDirection,
        in_terms: this.checked_terms,
        type: this.selected_role,
        q: this.search_query
      };

      this.userListing(null, $.param(_.omit( params, i => !i )));
    },

    exportAsCSV() {
      let params = {
        sort: this.sortParam,
        per_page: this.per_page,
        direction: this.sortDirection,
        in_terms: this.checked_terms,
        type: this.selected_role,
        q: this.search_query,
        format: 'csv'
      };
      var url = Kadenze.Routes.admin_users_path(params);
      window.location.href = url;
    }
  },

  created() {},

  mounted() {
    Kadenze.PaginationBinding.applyBindingsWithTextInput(this.userListing);

    var $dropDowns = $(this.$el).find('.js-table-dropdown');
    $dropDowns.off('shown.bs.dropdown').on('shown.bs.dropdown', function () {
      var $menu = $(this);
      new TableVM().updateMenuPosition($menu);
    });
    if (Kadenze.isKadenze) {
      this.roles.push(
        'autograde_admin',
        'for_credit',
        'kadenze_admin',
        'paid_subscriber',
        'premium_member',
        'proctor_admin',
        'super_moderator',
        'tester'
      );
    }

    if (Kadenze.isKannu) {
      this.roles.push('super_admin');
    }
    this.filter_roles = this.filteredRoles(this.roles);
  }
};
